package analytics

class LoggingAnalytics(
    private val logger: AnalyticsLogger = AnalyticsLogger.Println,
) : Analytics {
    override fun screen(name: String, properties: Map<String, Any?>) {
        logger.d("screen=$name properties=$properties")
    }

    override fun track(event: AnalyticsEvent) {
        logger.d("event=${event.name} properties=${event.properties}")
    }

    override fun identify(userId: String, properties: Map<String, Any?>) {
        logger.d("identify=$userId properties=$properties")
    }

    override fun setPersonProperties(properties: Map<String, Any?>) {
        logger.d("person=$properties")
    }

    override fun register(key: String, value: Any?) {
        logger.d("register $key=$value")
    }

    override fun unregister(key: String) {
        logger.d("unregister $key")
    }

    override fun optOut(optedOut: Boolean) {
        logger.d("optOut=$optedOut")
    }

    override fun reset() {
        logger.d("reset")
    }

    override fun flush() = Unit
}
